import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product-active",
  "use": "icon-product-active-usage",
  "viewBox": "0 0 58 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 58 51\" id=\"icon-product-active\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#FFF\" opacity=\".497\" x=\"8.286\" width=\"41.429\" height=\"37.529\" rx=\"8.529\" /><rect fill=\"#FFF\" y=\"11.015\" width=\"58\" height=\"39.771\" rx=\"8.529\" /><path stroke=\"#2F54EB\" stroke-width=\"3\" opacity=\".503\" stroke-linecap=\"round\" d=\"M17.4 40.6h23.2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol